<template>
  <!-- 主區域底層模板 -->
  <section class="drawer-layout Jost">
    <!-- 左邊 -->
    <section class="drawer-layout__left">
      <div class="drawer-layout__left-scroll">
        <!-- <div class="drawer-layout__left-header">
          <div
            >預約時間：
            <span style="color:#000000">2023/09/01 ~ 2023/09/03</span>
          </div>
          <div
            >服務地點：
            <span style="color:#000000">中山店</span>
          </div>
          <div
            >已選房型：
            <span style="color:#000000">小捲尾精品房 ＆ 輕奢經典房</span>
          </div>
        </div> -->
        <div class="drawer-layout__left-content">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 18px;">
            <el-button icon="el-icon-back" round @click="$emit('back-step', 2)">
              重新搜尋寵物
            </el-button>
            <!-- <div
              style="background:rgba(247, 71, 71, 0.2);
              color:#F74747;
              width:130px;height:35px;
              border-radius:8px;
              font-size: 16px;
              font-weight:500;
              text-align: center;
              line-height: 2.2;"
            >
              <i
                class="el-icon-time"
                style=" font-size: 16px;
                font-weight:700;"
              />
              04:39
            </div> -->
          </div>
          <!-- 客戶資訊 -->
          <CustomerInfo :info="currentMemberInfo" :currentStep="currentStep" style="margin-bottom: 18px;" @update="fetchCurrentMember" @merge-info="onMergeMemberInfo" />

          <!-- 選擇住宿列表 -->
          <AccommodationList :info="accommodationInfo" :currentStep="currentStep" :mode="'edit'" style="margin-bottom: 18px;" />

          <!-- 入住寵物列表 -->
          <CheckInPetListPartial :info="selectedPets" mode="create" style="margin-bottom:18px" @pet-tab-click="onClickPetTab" />

          <!-- 備註列表 -->
          <OrderNotePartial mode="edit" style="margin-bottom:18px" @update-order-note="setOrderNote" />
        </div>
      </div>
    </section>

    <!-- 右邊 -->
    <section class="drawer-layout__right">
      <template v-if="rightPanelView === 'order'">
        <div class="drawer-layout__right-scroll" style="margin-bottom: 18px;">
          <FinalOrderInfoPartial style="width:90%" @update-total="handleUpdateTotal" />
        </div>
      </template>
      <template v-else> </template>
    </section>

    <!-- 寵物資訊 Drawer -->
    <PetSidePanelPartial
      ref="petSidePanel"
      :visible.sync="isPetDetailDrawerShow"
      :pet-detail="selectedPetDetail"
      :initial-tab="petInfoActiveTab"
      :order-id="orderId"
      mode="create"
      @close="handleClosePetDetail"
      @updated="onPetInfoUpdated"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

import CustomerInfo from './partials/CustomerInfoPartial.vue'
import AccommodationList from './partials/AccommodationListPartial.vue'
import CheckInPetListPartial from './partials/CheckInPetListPartial.vue'
import OrderNotePartial from './partials/OrderNotrePartial.vue'
import FinalOrderInfoPartial from './partials/FinalOrderInfoPartial.vue'
import PetSidePanelPartial from './partials/PetSidePanelPartial.vue'
import PetCommentList from '@components/PetCommentList'
import API from '../../api'
import { fetchMemberShortWithSummary } from '@utils/memberV2Fetch'

export default {
  name: 'Step3hotelBooking',
  components: {
    CustomerInfo,
    AccommodationList,
    CheckInPetListPartial,
    OrderNotePartial,
    FinalOrderInfoPartial,
    PetSidePanelPartial,
    PetCommentList,
  },
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isPetDetailDrawerShow: false,
      rightPanelView: 'order', // order | pet
      petDetailCache: {},
      petInfoActiveTab: 'information',
      petInfoTabs: [{ name: 'information', label: '寵物資訊' }, { name: 'service', label: '歷史紀錄' }, { name: 'currentService', label: '服務紀錄' }],
      petInfoLoading: false,
      selectedPetDetail: {},
    }
  },
  watch: {
    selectedPets: {
      handler(newList) {
        if (this.currentProduct?.id && newList?.length > 0) {
          this.fetchPostHotelOrderCalculate()
        }

        if (!Array.isArray(newList) || newList.length === 0) {
          this.selectedPetDetail = {}
          this.rightPanelView = 'order'
          return
        }

        const currentId = this.selectedPetDetail && this.selectedPetDetail.id
        const nextPet = currentId ? newList.find((pet) => pet.id === currentId) : newList[0]
        if (!currentId || !nextPet) {
          this.onSelectPet(newList[0])
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters('hotel/order', ['selectedBookingRoomsList', 'currentMemberInfo', 'accommodationInfo', 'selectedPets', 'detailedBookingList']),
    ...mapGetters('hotel/setting', ['currentProduct']),
    selectedPetId() {
      if (this.selectedPetDetail && this.selectedPetDetail.id) return this.selectedPetDetail.id
      return this.selectedPets && this.selectedPets.length ? this.selectedPets[0].id : null
    },
    orderId() {
      // 在 Step 3 中，訂單可能還沒有創建，所以返回 null
      // 這個值會在服務紀錄中使用，用於關聯訂單
      return null
    },
    dummyOrder() {
      return {
        id: null,
        uuid: null,
        displayId: null,
        pet: this.selectedPetDetail,
        petId: this.selectedPetId,
      }
    },
  },

  methods: {
    async fetchCurrentMember() {
      const memberId = this.currentMemberInfo && this.currentMemberInfo.id
      if (!memberId) return
      const member = await fetchMemberShortWithSummary(this.$store, memberId)
      this.$store.commit('hotel/order/SET_MEMBER', member)
    },
    onMergeMemberInfo(member) {
      this.$store.commit('hotel/order/SET_MEMBER', member)
    },
    async fetchPostHotelOrderCalculate() {
      if (!this.currentProduct?.id) return
      try {
        const payload = {
          bookings: this.selectedBookingRoomsList.map((item) => ({
            date: item.date,
            roomTypeId: item.type.id,
            roomId: item.roomId,
            guestCount: this.selectedPets.length,
          })),
        }
        const calculateOrder = await API.order.postHotelOrderCalculate(this.currentProduct.id, payload)
        this.$store.commit('hotel/order/SET_CALCULATE', calculateOrder)
        console.log('res', calculateOrder)
      } catch (error) {
        console.log(error)
      }
    },
    handleUpdateTotal(val) {
      this.$emit('update-total', val)
    },
    setOrderNote(val) {
      this.$store.commit('hotel/order/SET_NOTE', val)
    },
    async onSelectPet(pet) {
      if (!pet || !pet.id) return
      const memberId = this.currentMemberInfo && this.currentMemberInfo.id
      let detail = this.petDetailCache[pet.id]

      if (!detail && memberId) {
        try {
          const { items } = await this.$store.dispatch('member/fetchSinglePet', { memberId, petId: pet.id })
          detail = items
          if (detail) {
            this.$set(this.petDetailCache, pet.id, detail)
          }
        } catch (err) {
          console.error(err)
        }
      }

      this.selectedPetDetail = {
        ...pet,
        ...(detail || {}),
      }
    },
    async onClickPetTab({ pet, tab }) {
      await this.onSelectPet(pet)
      this.isPetDetailDrawerShow = true
      if (tab === 'addService') {
        // 延遲打開新增服務紀錄抽屜，確保 PetSidePanelPartial 先渲染
        this.$nextTick(() => {
          if (this.$refs.petSidePanel) {
            this.$refs.petSidePanel.openNewServiceRecordDrawer()
          }
        })
      } else {
        const nextTab = ['information', 'service'].includes(tab) ? tab : 'information'
        this.petInfoActiveTab = nextTab
      }
    },
    handleClosePetDetail() {
      this.isPetDetailDrawerShow = false
      this.rightPanelView = 'order'
    },
    async onPetListUpdated() {
      await this.fetchCurrentMember()
      if (this.selectedPetDetail && this.selectedPetDetail.id) {
        await this.onSelectPet(this.selectedPetDetail)
      }
    },
    async onPetInfoUpdated(payload = {}) {
      const petId = payload && payload.id ? payload.id : this.selectedPetDetail && this.selectedPetDetail.id
      if (petId) {
        this.$delete(this.petDetailCache, petId)
      }
      // 寵物信息更新後，刷新寵物列表和當前選中寵物的詳細信息
      await this.onPetListUpdated()
    },
    onPetInfoLoadingChange(isLoading) {
      this.petInfoLoading = isLoading
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer-layout {
  display: flex;
  height: calc(100vh - 60px); // adjust if drawer header changes
  width: 100%;
  position: relative;
  margin: 0 20px 0 50px;

  &__left {
    width: 50%;
    height: 100%;
    overflow: hidden;
    border-right: 2px solid #e6e6e6;
    display: flex;
    flex-direction: column;

    &-scroll {
      flex: 1;
      overflow-y: auto;
      display: flex;
      flex-direction: column;

      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #999;
        border-radius: 4px;
        border: 2px solid #f0f0f0;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #666;
      }
    }

    &-header {
      position: sticky;
      top: 8px;
      padding-top: 18px;
      z-index: 10;
      background-color: #f9f9fb;
      border-bottom: 1px solid #e6e6e6;
      font-size: 18px;
      font-weight: 700;
      line-height: 2.2;
    }

    &-content {
      margin: 20px 20px 0px 0px;
    }
  }

  &__right {
    width: 50%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &-scroll {
      flex: 1;
      overflow-y: auto;
      padding: 16px;
      padding-right: 30px;
      font-size: 16px;
      line-height: 1.8;

      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #999;
        border-radius: 4px;
        border: 2px solid #f0f0f0;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #666;
      }
    }
  }
}
</style>
